import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion"

const SimpleAudioVisualizer = ({ ttsRef, style }) => {
  const [circleSize, setCircleSize] = useState(50);

  useEffect(() => {
    const audioElement = ttsRef.current;
    if (audioElement) {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const analyser = audioContext.createAnalyser();
      const source = audioContext.createMediaElementSource(audioElement);

      source.connect(analyser);
      analyser.connect(audioContext.destination);

      analyser.fftSize = 256;
      const bufferLength = analyser.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      const updateCircleSize = () => {
        analyser.getByteFrequencyData(dataArray);
        const average = dataArray.reduce((acc, val) => acc + val, 0) / bufferLength;
        const size = 100 + (average / 255) * 100;
        setCircleSize(size);
        requestAnimationFrame(updateCircleSize);
      };

      updateCircleSize();

      return () => {
        audioContext.close();
      };
    }
  }, [ttsRef.current]);

  return (
    <motion.div
      style={{
        ...style,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <motion.div
        animate={{ width: circleSize * 1.3, height: circleSize * 1.3 }}
        transition={{
          ease: "linear",
          duration: 0.2,
        }}
        style={{
          borderRadius: '50%',
          backgroundColor: '#6a1b9a',
          opacity: 0.5,
          position: 'absolute',
        }}
      />
      <motion.div
        style={{
          width: circleSize,
          height: circleSize,
          borderRadius: '50%',
          backgroundColor: '#6a1b9a',
          position: 'relative',
        }}
      />
    </motion.div>
  );
};

export default SimpleAudioVisualizer;
